export var OddsStyle;
(function (OddsStyle) {
    OddsStyle["decimal"] = "decimal";
    OddsStyle["american"] = "american";
    OddsStyle["fractional"] = "fractional";
})(OddsStyle || (OddsStyle = {}));
export var RacingCastPositions;
(function (RacingCastPositions) {
    RacingCastPositions[RacingCastPositions["any"] = 0] = "any";
    RacingCastPositions[RacingCastPositions["first"] = 1] = "first";
    RacingCastPositions[RacingCastPositions["second"] = 2] = "second";
    RacingCastPositions[RacingCastPositions["third"] = 3] = "third";
})(RacingCastPositions || (RacingCastPositions = {}));
export var BetType;
(function (BetType) {
    BetType[BetType["Unknown"] = 0] = "Unknown";
    BetType[BetType["Single"] = 1] = "Single";
    BetType[BetType["Combo"] = 2] = "Combo";
    BetType[BetType["Forecast"] = 3] = "Forecast";
    BetType[BetType["Tricast"] = 4] = "Tricast";
    BetType[BetType["OtherCast"] = 5] = "OtherCast";
    BetType[BetType["Kombinator"] = 6] = "Kombinator";
    BetType[BetType["System2from3"] = 10] = "System2from3";
    BetType[BetType["Trixie"] = 11] = "Trixie";
    BetType[BetType["Patent"] = 12] = "Patent";
    BetType[BetType["System2from4"] = 13] = "System2from4";
    BetType[BetType["System3from4"] = 14] = "System3from4";
    BetType[BetType["Yankee"] = 15] = "Yankee";
    BetType[BetType["Lucky15"] = 16] = "Lucky15";
    BetType[BetType["System2from5"] = 17] = "System2from5";
    BetType[BetType["System3from5"] = 18] = "System3from5";
    BetType[BetType["System4from5"] = 19] = "System4from5";
    BetType[BetType["SuperYankee"] = 20] = "SuperYankee";
    BetType[BetType["Lucky31"] = 21] = "Lucky31";
    BetType[BetType["System2from6"] = 22] = "System2from6";
    BetType[BetType["System3from6"] = 23] = "System3from6";
    BetType[BetType["System4from6"] = 24] = "System4from6";
    BetType[BetType["System5from6"] = 25] = "System5from6";
    BetType[BetType["Heinz"] = 26] = "Heinz";
    BetType[BetType["Lucky63"] = 27] = "Lucky63";
    BetType[BetType["System2from7"] = 28] = "System2from7";
    BetType[BetType["System3from7"] = 29] = "System3from7";
    BetType[BetType["System4from7"] = 30] = "System4from7";
    BetType[BetType["System5from7"] = 31] = "System5from7";
    BetType[BetType["System6from7"] = 32] = "System6from7";
    BetType[BetType["SuperHeinz"] = 33] = "SuperHeinz";
    BetType[BetType["System2from8"] = 34] = "System2from8";
    BetType[BetType["System3from8"] = 35] = "System3from8";
    BetType[BetType["System4from8"] = 36] = "System4from8";
    BetType[BetType["System5from8"] = 37] = "System5from8";
    BetType[BetType["System6from8"] = 38] = "System6from8";
    BetType[BetType["System7from8"] = 39] = "System7from8";
    BetType[BetType["Goliath"] = 40] = "Goliath";
    BetType[BetType["System2from9"] = 41] = "System2from9";
    BetType[BetType["System3from9"] = 42] = "System3from9";
    BetType[BetType["System4from9"] = 43] = "System4from9";
    BetType[BetType["System5from9"] = 44] = "System5from9";
    BetType[BetType["System6from9"] = 45] = "System6from9";
    BetType[BetType["System7from9"] = 46] = "System7from9";
    BetType[BetType["System8from9"] = 47] = "System8from9";
    BetType[BetType["System2from10"] = 48] = "System2from10";
    BetType[BetType["System3from10"] = 49] = "System3from10";
    BetType[BetType["System4from10"] = 50] = "System4from10";
    BetType[BetType["System5from10"] = 51] = "System5from10";
    BetType[BetType["System6from10"] = 52] = "System6from10";
    BetType[BetType["System7from10"] = 53] = "System7from10";
    BetType[BetType["System8from10"] = 54] = "System8from10";
    BetType[BetType["System9from10"] = 55] = "System9from10";
    BetType[BetType["System2from11"] = 56] = "System2from11";
    BetType[BetType["System3from11"] = 57] = "System3from11";
    BetType[BetType["System4from11"] = 58] = "System4from11";
    BetType[BetType["System5from11"] = 59] = "System5from11";
    BetType[BetType["System6from11"] = 60] = "System6from11";
    BetType[BetType["System7from11"] = 61] = "System7from11";
    BetType[BetType["System8from11"] = 62] = "System8from11";
    BetType[BetType["System9from11"] = 63] = "System9from11";
    BetType[BetType["System10from11"] = 64] = "System10from11";
    BetType[BetType["System2from12"] = 65] = "System2from12";
    BetType[BetType["System3from12"] = 66] = "System3from12";
    BetType[BetType["System4from12"] = 67] = "System4from12";
    BetType[BetType["System5from12"] = 68] = "System5from12";
    BetType[BetType["System6from12"] = 69] = "System6from12";
    BetType[BetType["System7from12"] = 70] = "System7from12";
    BetType[BetType["System8from12"] = 71] = "System8from12";
    BetType[BetType["System9from12"] = 72] = "System9from12";
    BetType[BetType["System10from12"] = 73] = "System10from12";
    BetType[BetType["System11from12"] = 74] = "System11from12";
    BetType[BetType["System2from13"] = 75] = "System2from13";
    BetType[BetType["System3from13"] = 76] = "System3from13";
    BetType[BetType["System4from13"] = 77] = "System4from13";
    BetType[BetType["System5from13"] = 78] = "System5from13";
    BetType[BetType["System6from13"] = 79] = "System6from13";
    BetType[BetType["System7from13"] = 80] = "System7from13";
    BetType[BetType["System8from13"] = 81] = "System8from13";
    BetType[BetType["System9from13"] = 82] = "System9from13";
    BetType[BetType["System10from13"] = 83] = "System10from13";
    BetType[BetType["System11from13"] = 84] = "System11from13";
    BetType[BetType["System12from13"] = 85] = "System12from13";
    BetType[BetType["System2from14"] = 86] = "System2from14";
    BetType[BetType["System3from14"] = 87] = "System3from14";
    BetType[BetType["System4from14"] = 88] = "System4from14";
    BetType[BetType["System5from14"] = 89] = "System5from14";
    BetType[BetType["System6from14"] = 90] = "System6from14";
    BetType[BetType["System7from14"] = 91] = "System7from14";
    BetType[BetType["System8from14"] = 92] = "System8from14";
    BetType[BetType["System9from14"] = 93] = "System9from14";
    BetType[BetType["System10from14"] = 94] = "System10from14";
    BetType[BetType["System11from14"] = 95] = "System11from14";
    BetType[BetType["System12from14"] = 96] = "System12from14";
    BetType[BetType["System13from14"] = 97] = "System13from14";
    BetType[BetType["System2from15"] = 98] = "System2from15";
    BetType[BetType["System3from15"] = 99] = "System3from15";
    BetType[BetType["System4from15"] = 100] = "System4from15";
    BetType[BetType["System5from15"] = 101] = "System5from15";
    BetType[BetType["System10from15"] = 102] = "System10from15";
    BetType[BetType["System11from15"] = 103] = "System11from15";
    BetType[BetType["System12from15"] = 104] = "System12from15";
    BetType[BetType["System13from15"] = 105] = "System13from15";
    BetType[BetType["System14from15"] = 106] = "System14from15";
    BetType[BetType["System2from16"] = 107] = "System2from16";
    BetType[BetType["System3from16"] = 108] = "System3from16";
    BetType[BetType["System4from16"] = 109] = "System4from16";
    BetType[BetType["System12from16"] = 110] = "System12from16";
    BetType[BetType["System13from16"] = 111] = "System13from16";
    BetType[BetType["System14from16"] = 112] = "System14from16";
    BetType[BetType["System15from16"] = 113] = "System15from16";
    BetType[BetType["System2from17"] = 114] = "System2from17";
    BetType[BetType["System3from17"] = 115] = "System3from17";
    BetType[BetType["System4from17"] = 116] = "System4from17";
    BetType[BetType["System13from17"] = 117] = "System13from17";
    BetType[BetType["System14from17"] = 118] = "System14from17";
    BetType[BetType["System15from17"] = 119] = "System15from17";
    BetType[BetType["System16from17"] = 120] = "System16from17";
    BetType[BetType["System2from18"] = 121] = "System2from18";
    BetType[BetType["System3from18"] = 122] = "System3from18";
    BetType[BetType["System4from18"] = 123] = "System4from18";
    BetType[BetType["System14from18"] = 124] = "System14from18";
    BetType[BetType["System15from18"] = 125] = "System15from18";
    BetType[BetType["System16from18"] = 126] = "System16from18";
    BetType[BetType["System17from18"] = 127] = "System17from18";
    BetType[BetType["System2from19"] = 128] = "System2from19";
    BetType[BetType["System3from19"] = 129] = "System3from19";
    BetType[BetType["System16from19"] = 130] = "System16from19";
    BetType[BetType["System17from19"] = 131] = "System17from19";
    BetType[BetType["System18from19"] = 132] = "System18from19";
    BetType[BetType["System2from20"] = 133] = "System2from20";
    BetType[BetType["System3from20"] = 134] = "System3from20";
    BetType[BetType["System17from20"] = 135] = "System17from20";
    BetType[BetType["System18from20"] = 136] = "System18from20";
    BetType[BetType["System19from20"] = 137] = "System19from20";
    BetType[BetType["StraightForecast"] = 138] = "StraightForecast";
    BetType[BetType["ReversedForecast"] = 139] = "ReversedForecast";
    BetType[BetType["CombinationForecast"] = 140] = "CombinationForecast";
    BetType[BetType["StraightTricast"] = 141] = "StraightTricast";
    BetType[BetType["CombinationTricast"] = 142] = "CombinationTricast";
    BetType[BetType["ToteWin"] = 143] = "ToteWin";
    BetType[BetType["TotePlace"] = 144] = "TotePlace";
    BetType[BetType["ToteShow"] = 145] = "ToteShow";
    BetType[BetType["ToteWinPlace"] = 146] = "ToteWinPlace";
    BetType[BetType["ToteWinShow"] = 147] = "ToteWinShow";
    BetType[BetType["ToteWinPlaceShow"] = 148] = "ToteWinPlaceShow";
    BetType[BetType["TotePlaceShow"] = 149] = "TotePlaceShow";
    BetType[BetType["ToteExacta"] = 150] = "ToteExacta";
    BetType[BetType["ToteQuinella"] = 151] = "ToteQuinella";
    BetType[BetType["ToteTrifecta"] = 152] = "ToteTrifecta";
    BetType[BetType["ToteSuperfecta"] = 153] = "ToteSuperfecta";
    BetType[BetType["TotePentafecta"] = 154] = "TotePentafecta";
    BetType[BetType["ToteOmni"] = 155] = "ToteOmni";
    BetType[BetType["ToteDailyDouble"] = 156] = "ToteDailyDouble";
    BetType[BetType["TotePick3"] = 157] = "TotePick3";
    BetType[BetType["TotePick4"] = 158] = "TotePick4";
    BetType[BetType["TotePick5"] = 159] = "TotePick5";
    BetType[BetType["TotePick6"] = 160] = "TotePick6";
    BetType[BetType["TotePick7"] = 161] = "TotePick7";
    BetType[BetType["TotePick8"] = 162] = "TotePick8";
    BetType[BetType["TotePick9"] = 163] = "TotePick9";
    BetType[BetType["TotePick10"] = 164] = "TotePick10";
    BetType[BetType["ToteGrandSlam"] = 165] = "ToteGrandSlam";
    BetType[BetType["YourBet"] = 166] = "YourBet";
    BetType[BetType["Teaser"] = 167] = "Teaser";
})(BetType || (BetType = {}));
var CombinabilityRestrictionType;
(function (CombinabilityRestrictionType) {
    CombinabilityRestrictionType[CombinabilityRestrictionType["SinglesOnly"] = 0] = "SinglesOnly";
    CombinabilityRestrictionType[CombinabilityRestrictionType["ComboDisallowed"] = 1] = "ComboDisallowed";
    CombinabilityRestrictionType[CombinabilityRestrictionType["SystemDisallowed"] = 2] = "SystemDisallowed";
    CombinabilityRestrictionType[CombinabilityRestrictionType["TeaserDisallowed"] = 3] = "TeaserDisallowed";
    CombinabilityRestrictionType[CombinabilityRestrictionType["NonCombinableGroup"] = 4] = "NonCombinableGroup";
})(CombinabilityRestrictionType || (CombinabilityRestrictionType = {}));
export var SelectionStatus;
(function (SelectionStatus) {
    SelectionStatus["Active"] = "Active";
    SelectionStatus["Disabled"] = "Disabled";
    SelectionStatus["NonRunner"] = "NonRunner";
})(SelectionStatus || (SelectionStatus = {}));
export var PurchaseStatus;
(function (PurchaseStatus) {
    PurchaseStatus[PurchaseStatus["Open"] = 0] = "Open";
    PurchaseStatus[PurchaseStatus["NewOffer"] = 1] = "NewOffer";
    PurchaseStatus[PurchaseStatus["Declined"] = 2] = "Declined";
    PurchaseStatus[PurchaseStatus["LiveDelay"] = 3] = "LiveDelay";
    PurchaseStatus[PurchaseStatus["TraderDelay"] = 4] = "TraderDelay";
})(PurchaseStatus || (PurchaseStatus = {}));
export var PurchaseSelectionStatus;
(function (PurchaseSelectionStatus) {
    PurchaseSelectionStatus[PurchaseSelectionStatus["Active"] = 0] = "Active";
    PurchaseSelectionStatus[PurchaseSelectionStatus["Closed"] = 1] = "Closed";
    PurchaseSelectionStatus[PurchaseSelectionStatus["Settled"] = 2] = "Settled";
    PurchaseSelectionStatus[PurchaseSelectionStatus["Suspended"] = 3] = "Suspended";
})(PurchaseSelectionStatus || (PurchaseSelectionStatus = {}));
export var SelectionTags;
(function (SelectionTags) {
    SelectionTags["SP"] = "SP";
    SelectionTags["Place"] = "Place";
    SelectionTags["SPPlace"] = "SPPlace";
    SelectionTags["MainPointLine"] = "MainPointLine";
})(SelectionTags || (SelectionTags = {}));
// namespace APIErrors {
//     // Response.status === 400 || Response.status === 500
//     enum CalculateBetsStatusCodes {
//         General,
//         ValidationError,
//         InvalidSelection,
//         UnaplicableRequest,
//         InvalidCastBetPosition,
//         RacingCastNotAvailable,
//         MaxNumberOfSelectionsExceeded,
//     }
//     interface CalculateBetsErrorMessage {
//         statusDescription: string
//         statusCode: calculateBetsStatusCodes
//     }
//     // Response.status === 400 | Response.status === 422
//     interface PlaceBetDeclinedReasons {
//         WaitLive,
//         MaxBetOver,
//         StakeTooLow,
//         StakeTooHigh,
//         OddsNotMatch,
//         NotEnoughMoney,
//         FreeBetExpired,
//         PointsNotMatch,
//         SelectionClosed,
//         ComboNotAllowed,
//         FreeBetNotFound,
//         FreeBetNotAllowed,
//         InvalidComboBonus,
//         MaxExposurereached,
//         SelectionSuspended,
//         UnaplicableRequest,
//         NewBetBelowMinimum,
//         CustomerLiveBetNotAllowed,
//         SelfImposedLimitesExceeded,
//         InvalidComboBonusPercentage,
//         PartialCashOutNotAllowedForBet
//     }
//     interface PlaceBetStatusCodes {
//         InvalidBetType,
//         ValidationError,
//         IncorectBetType,
//         InvalidSelection,
//         SelectionNotFound,
//         RepeatedSelections,
//         EachWayOddsChanged,
//         PurchaseNotAccepted,
//         InvalidPotentialReturns,
//         IncorrectLinesforBetType,
//         BetSelectionMappingIsNotValid
//     }
//     interface PlaceBetErrorMessage: {
//         statusDescription: string
//         statusCode: calculateBetsStatusCodes
//     }
// }
//# sourceMappingURL=Common.js.map